(function () {
  var FALLBACK_HEADER_SECTION_ID = 'celltail_header';

  function getHeaderSectionId() {
    var drawer = document.querySelector('cart-drawer-component');
    var section = drawer && drawer.closest('.shopify-section');
    if (section && section.id) {
      return section.id.replace(/^shopify-section-/, '');
    }
    return FALLBACK_HEADER_SECTION_ID;
  }

  async function refreshCartDrawer() {
    try {
      var sectionId = getHeaderSectionId();
      var url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);
      var res = await fetch(url.toString());
      if (!res.ok) {
        console.error('Celltail: cart drawer section fetch failed', res.status, sectionId);
        return;
      }
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newDrawer = doc.querySelector('cart-drawer-component');
      var oldDrawer = document.querySelector('cart-drawer-component');
      if (newDrawer && oldDrawer) {
        oldDrawer.replaceWith(newDrawer);
        if (typeof newDrawer.open === 'function') {
          newDrawer.open();
        }
      } else if (oldDrawer && typeof oldDrawer.open === 'function') {
        oldDrawer.open();
      }

      /* Notify the theme (cart icon bubble, cart page items) with the same
         event shape the theme's own CartUpdateEvent uses: detail.data is
         required, otherwise listeners throw and the cart UI goes stale. */
      var cart = null;
      try {
        cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
      } catch (e) {}
      var sections = {};
      sections[sectionId] = html;
      var evt = new Event('cart:update', { bubbles: true });
      evt.detail = {
        resource: cart,
        sourceId: 'celltail-cart',
        data: {
          source: 'celltail-cart',
          itemCount: cart ? cart.item_count : 0,
          sections: sections,
        },
      };
      document.dispatchEvent(evt);
    } catch (err) {
      console.error('Celltail: failed to refresh cart drawer', err);
    }
  }

  async function celltailAddToCart(payload, opts) {
    opts = opts || {};
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    var data = await res.json();
    if (!res.ok) {
      var message = (data && (data.description || data.message)) || 'Could not add to cart';
      if (typeof opts.onError === 'function') opts.onError(message);
      throw new Error(message);
    }
    await refreshCartDrawer();
    if (typeof opts.onSuccess === 'function') opts.onSuccess(data);
    return data;
  }

  window.celltailAddToCart = celltailAddToCart;
  window.celltailRefreshCartDrawer = refreshCartDrawer;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.ct-add-to-cart-form');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var formData = new FormData(form);
    var item = {};
    formData.forEach(function (value, key) {
      if (key === 'id') item.id = value;
      else if (key === 'quantity') item.quantity = parseInt(value, 10) || 1;
      else if (key === 'selling_plan') {
        if (value) item.selling_plan = value;
      } else if (key.indexOf('properties[') === 0) {
        item.properties = item.properties || {};
        item.properties[key.slice(11, -1)] = value;
      }
    });
    if (!item.id) return;
    if (!item.quantity) item.quantity = 1;

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
    }

    celltailAddToCart(
      { items: [item] },
      {
        onSuccess: function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.classList.remove('is-loading');
          }
        },
        onError: function (message) {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.classList.remove('is-loading');
          }
          window.alert(message);
        },
      }
    ).catch(function () {});
  });

  /* ------------------------------------------------------------------
   * Purchase-option toggle (One-time vs Subscribe & Save) + quantity
   * stepper, shared by the homepage product hero and the main product
   * page. Works off plain data attributes so no framework is needed.
   * ------------------------------------------------------------------ */
  function formatMoney(cents, currency) {
    /* Whole amounts read cleaner on the button: "€39" rather than "€39.00". */
    var amount = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
    return currency + amount;
  }

  function initProductForm(form) {
    var qtyInput = form.querySelector('[data-ct-qty-input]');
    var decBtn = form.querySelector('[data-ct-qty-decrease]');
    var incBtn = form.querySelector('[data-ct-qty-increase]');
    var sellingPlanInput = form.querySelector('[data-ct-selling-plan-input]');
    var options = form.querySelectorAll('[data-ct-option]');
    var totalEl = form.querySelector('[data-ct-total-price]');
    var currency = form.getAttribute('data-ct-currency') || '€';

    function activeOption() {
      var checked = form.querySelector('input[name="ct_purchase_mode"]:checked');
      if (checked) return checked.closest('[data-ct-option]');
      return options[0] || null;
    }

    function update() {
      var opt = activeOption();
      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
      var price = opt ? parseInt(opt.getAttribute('data-price'), 10) || 0 : 0;
      if (totalEl) totalEl.textContent = formatMoney(price * qty, currency);
      if (sellingPlanInput) {
        sellingPlanInput.value = opt && opt.getAttribute('data-mode') === 'subscription' ? opt.getAttribute('data-selling-plan-id') : '';
      }
      options.forEach(function (o) {
        o.classList.toggle('is-active', o === opt);
      });
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        var radio = opt.querySelector('input[type=radio]');
        if (radio) radio.checked = true;
        update();
      });
    });

    if (decBtn) {
      decBtn.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = v;
        update();
      });
    }
    if (incBtn) {
      incBtn.addEventListener('click', function () {
        var v = Math.min(10, (parseInt(qtyInput.value, 10) || 1) + 1);
        qtyInput.value = v;
        update();
      });
    }
    if (qtyInput) qtyInput.addEventListener('change', update);

    update();
  }

  document.querySelectorAll('[data-ct-product-form]').forEach(initProductForm);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ct-product-form]').forEach(initProductForm);
  });
})();
